import { updateMSTObject } from 'helpers';
import { types as t, flow, applySnapshot } from 'mobx-state-tree';

import { api } from 'api';
import { config } from 'app-config';
import { JobBoardsStore } from 'jobboards/JobBoardsStore';
import { ApplicationStore } from 'models/applications';
import { CompanyInfo, CompanyUISettings } from 'models/companies';
import { JobStore } from 'models/jobs';
import { TemplateStore } from 'models/templates';
import { LoadingState } from 'models/ui';
import { UserRole, UserStore } from 'models/users';
import { withEnv } from 'models/withEnv';

// Use this to begin with to ease migration until we can move this out of mobx
const TemporaryWhoAmI = t.model('WhoAmI', {
  id: t.identifierNumber,
  uuid: t.string,
  name: t.string,
  email: t.string,
  picture: t.maybeNull(t.string),
  role: UserRole,
  departmentIds: t.maybeNull(t.array(t.number)),
});

export const Company = t
  .model('Company', {
    id: t.identifierNumber,
    info: t.maybe(CompanyInfo),
    whoami: TemporaryWhoAmI,
    jobs: t.optional(JobStore, {}),
    applications: t.optional(ApplicationStore, {}),
    users: t.optional(UserStore, {}),
    templates: t.optional(TemplateStore, {}),
    jobboards: t.optional(JobBoardsStore, {}),

    uiSettings: t.optional(CompanyUISettings, {}),
    state: LoadingState,
  })
  .views(withEnv)
  .views((self) => ({
    get langs() {
      return self.info.langs;
    },
    get careersUrl() {
      return `${config.CAREERS_URL}/${self.info.name}`;
    },
    get api() {
      return api;
    },
    get rejectionTemplates() {
      return self.templates.emailTemplates.filter((t) => t.templateType === 'rejection');
    },
    get messageTemplates() {
      return self.templates.emailTemplates.filter((t) => t.templateType === 'message');
    },
  }))
  .actions((self) => ({
    loadInfo: flow(function* () {
      const res = yield self.api.companies.load();
      if (res.status === 200) {
        self.info = res.data;
      }
    }),
    load: flow(function* () {
      self.state = 'loading';
      if (self.whoami.role !== 'user') {
        self.templates.load();
      } else {
        yield self.users.loadIndividual(self.whoami.id);
      }

      yield self.users.load();
      self.state = 'loaded';
    }),
    loadTemplates: flow(function* () {
      const res = yield self.api.companies.loadTemplates();
      if (!res.error) {
        const data = res.data.filter((template) => template.company.id === self.id);
        applySnapshot(self.templates, data);
      }
    }),
    update: flow(function* (data) {
      updateMSTObject(self.info, data);
      return yield Promise.resolve(true);
    }),
  }));
